@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.mainFilter {
	margin: 0 Constants.$val-spacing-s;

	& :global(.dropdown-toggle) {
		padding: 0 Constants.$val-spacing-xs 0 Constants.$val-spacing-s;
	}

	& :global(.dropdown-item__content) {
		display: flex;
		align-items: center;
		white-space: nowrap;
		padding-right: 0;
	}

	& :global(.dropdown-menu__selected) {
		display: flex;
		align-items: center;
	}

	& :global(.dropdown-menu__with-caret) {
		margin-left: Constants.$val-spacing-s;
	}

	& :global(.dropdown-menu__close-icon) {
		padding-right: Constants.$val-spacing-xs;
	}
}

.noneOption {
	color: Colors.$col-greyFontLight;
}

.dropdownOption {
	white-space: nowrap;
	min-width: 220px;

	& + div {
		margin-left: Constants.$val-spacing-s;
	}
}

.appliedFilter {
	background-color: Colors.$col-white;
	border: 1px solid Colors.$col-greyMid;
	display: flex;
}

.appliedFilterContent {
	color: Colors.$col-greyDark;
	display: flex;
	white-space: nowrap;
}

.emptyFilter {
	border: 1px solid Colors.$col-greyMid;
}

.emptyFilterContent {
	color: Colors.$col-greyDark;
}

.bulkModalStyle {
	background-color: Colors.$col-white;
	border: 1px solid Colors.$col-design-grey14;
	margin: 0;

	.appliedFilterContent {
		color: Colors.$col-greyDark;
	}
}